import React, { useEffect, useState } from "react";
import { Link, useRouterState } from "@tanstack/react-router";
import {
  MenuOutlined,
  CloseOutlined,
} from "@ant-design/icons";

type NavItem = {
  label: string;
  to: string;
};

const navItems: NavItem[] = [
  {
    label: "Schedules",
    to: "/schedules",
  },
  {
    label: "History",
    to: "/list",
  },
  {
    label: "YouTube",
    to: "/youtube",
  },
  {
    label: "Configuration",
    to: "/config",
  },
  {
    label: "Player",
    to: "/player",
  },
  {
    label: "Report",
    to: "/report",
  },
];

function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const pathname = useRouterState().location.pathname;

  const isLoggedIn = Boolean(localStorage.getItem("AUTH_TOKEN"));

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [pathname]);

  const renderNavItem = (item: NavItem, mobile = false) => {
    const className = mobile
      ? "block rounded-md px-4 py-3 text-sm font-medium text-white/75 no-underline transition-colors duration-200 hover:bg-white/10 hover:text-white"
      : "rounded-md px-3 py-2.5 text-[13px] font-medium text-white/75 no-underline transition-colors duration-200 hover:bg-white/10 hover:text-white";

    return (
      <Link
        key={item.label}
        to={item.to}
        onClick={closeMobileMenu}
        className={className}
      >
        {item.label}
      </Link>
    );
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-[#1D1F5D] text-white shadow-md">
      <nav className="mx-auto flex h-[72px] max-w-[1440px] items-center justify-between px-5 sm:px-8 lg:px-10">
        {/* Logo */}
        <Link
          to="/"
          onClick={closeMobileMenu}
          className="flex shrink-0 items-center no-underline"
        >
          <img
            src="/kgs-studio.png"
            alt="KGS Studio"
            className="h-[48px] w-auto object-contain"
          />
        </Link>

        <div className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => renderNavItem(item))}
        </div>
        {isLoggedIn ? (
          <Link
            to="/dashboard"
            className="hidden items-center gap-2 rounded-md bg-[#00B86B] px-5 py-2.5 text-[13px] font-semibold text-white no-underline shadow-sm transition-all duration-200 active:scale-95  hover:shadow-md lg:flex"
          >
           
            Dashboard
          </Link>
        ) : (
          <Link
            to="/login"
            className="hidden items-center gap-2 rounded-md bg-[#00B86B] px-5 py-2.5 text-[13px] font-semibold text-white no-underline shadow-sm transition-all duration-200 active:scale-95 hover:shadow-md lg:flex"
          >
           
            Login
          </Link>
        )}

        <button
          type="button"
          aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
          aria-expanded={mobileMenuOpen}
          onClick={() => setMobileMenuOpen((prev) => !prev)}
          className="flex h-10 w-10 items-center justify-center rounded-md border-0 bg-transparent text-white transition-colors duration-200 hover:bg-white/10 lg:hidden"
        >
          {mobileMenuOpen ? (
            <CloseOutlined className="text-lg" />
          ) : (
            <MenuOutlined className="text-lg" />
          )}
        </button>
      </nav>

      <div
        className={`overflow-hidden border-t border-white/10 bg-[#161846] transition-all duration-300 ease-in-out lg:hidden ${
          mobileMenuOpen
            ? "max-h-[500px] translate-y-0 opacity-100"
            : "pointer-events-none max-h-0 -translate-y-2 opacity-0"
        }`}
      >
        <div className="mx-auto max-w-[1440px] px-5 py-4 sm:px-8">
          <div className="flex flex-col gap-1">
            {navItems.map((item) => renderNavItem(item, true))}

            <div className="my-3 border-t border-white/10" />

            {isLoggedIn ? (
              <Link
                to="/dashboard"
                onClick={closeMobileMenu}
                className="flex items-center justify-center gap-2 rounded-md bg-[#00B86B] px-5 py-3 text-center text-sm font-semibold text-white no-underline transition-all duration-200 active:scale-95"
              >
             
                Dashboard
              </Link>
            ) : (
              <Link
                to="/login"
                onClick={closeMobileMenu}
                className="flex items-center justify-center gap-2 rounded-md bg-[#00B86B] px-5 py-3 text-center text-sm font-semibold text-white no-underline transition-all duration-200 active:scale-95"
              >
            
                Login
              </Link>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Navbar;